import Vue from "vue"
import Router from "vue-router"
import FormConfigProvider from "../components/FormConfigProvider.vue"
import Confirmation from "../components/CheckoutComponents/Confirmation.vue"
import WelcomeTemplate from "../components/WelcomeTemplate.vue"
import Push from "../components/CheckoutComponents/Push.vue"

// import KlarnaCheckoutTest from '../components/CheckoutComponents/KlarnaCheckoutTest.vue'
// import ConfirmationTest from '../components/CheckoutComponents/ConfirmationTest.vue'
// import BankIdTestV6 from "../components/CheckoutComponents/BankIdTestV6.vue"
Vue.use(Router)

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "Default",
      component: WelcomeTemplate
    },
    {
      path: "/recept",
      name: "Recept",
      component: FormConfigProvider
    },
    {
      path: "/confirmation/:sid",
      component: Confirmation,
      props: true
    },
    {
      path: "/push/:sid",
      component: Push,
      props: true
    },
    // {
    //   path: "/bankidtestV6",
    //   component: BankIdTestV6,
    //   props: true
    // },
    // {
    //     path: '/confirmation-test/:sid',
    //     component: ConfirmationTest,
    //     props: true
    // },
    {
      path: "/api"
    }
  ]
})
